import React from "react";
import { Div } from "components/Base";

const TitleBox = ({ width = 60, styleProps = {} }) => (
  <Div bg="neutral3" width={width} height={5} bra={3} mb={2} {...styleProps} />
);

export default TitleBox;
